import { z } from 'zod';

/**
 * Change Order — customer-facing scope delta with baseline impact.
 * Both `deltaCents` and `deltaDays` are signed integers: negative
 * values mean the scope is shrinking. Approval of a CO re-baselines
 * the project budget/schedule for curva-S.
 */
export const changeOrderStatusSchema = z.enum([
  'draft',
  'submitted',
  'approved',
  'rejected',
  'cancelled',
]);
export type ChangeOrderStatus = z.infer<typeof changeOrderStatusSchema>;

export const changeOrderSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  code: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  status: changeOrderStatusSchema,
  deltaCents: z.number().int(),
  deltaDays: z.number().int(),
  attachments: z.array(z.string()),
  submittedAt: z.string().nullable(),
  decidedBy: z.string().nullable(),
  decidedByName: z.string().nullable(),
  decidedAt: z.string().nullable(),
  rejectedReason: z.string().nullable(),
  createdBy: z.string(),
  createdByName: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ChangeOrder = z.infer<typeof changeOrderSchema>;

export const createChangeOrderRequestSchema = z.object({
  title: z.string().trim().min(2).max(160),
  description: z.string().trim().max(4000).optional(),
  deltaCents: z.number().int(),
  deltaDays: z.number().int(),
  attachments: z.array(z.string()).max(20).optional(),
});
export type CreateChangeOrderRequest = z.infer<
  typeof createChangeOrderRequestSchema
>;

export const decideChangeOrderRequestSchema = z.object({
  reason: z.string().trim().max(2000).optional(),
});
export type DecideChangeOrderRequest = z.infer<
  typeof decideChangeOrderRequestSchema
>;
